export const getLocationNameById = (locationsData = [], locationId) => {
  if (!Array.isArray(locationsData)) return false;
 
  const locationName = locationsData.filter(item => item?.rec_id == locationId);
  
  if (locationName?.length > 0) {
    return locationName[0]?.location_short_code || false;
  }
 
  return false;
};
